<script lang="ts">
	import { checkVisibility } from '$lib/actions/checkVisibility';
	import { type Component } from 'svelte';
	import SbRichtext from '../components/sbRichtext.svelte';
	import Button from '$lib/buttons/v3/button.svelte';
	import type { Props as TypeformPopupProps } from '$lib/storyblok/parts/typeform/typeformPopup.svelte';
	import { identifySubmission } from '$lib/utils/typeform';
	import PageGrid16 from '../components/pageGrid16.svelte';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			typeform_id: string;
			bg_color: string;
			title_color: string;
			text_color: string;
			title: string;
			text: ISbRichtext;
			cta_text: string;
			cta_color: 'default' | 'btn-white' | 'btn-brown';
		}>['content'];
	}

	let { content }: Props = $props();

	let PopupComponent = $state<Component<TypeformPopupProps>>();
	let popup = $state<TypeformPopupProps['popup']>();
</script>

<section
	use:editable={content}
	use:checkVisibility
	onvisible={async ({ detail }) => {
		if (!detail) return;

		if (!PopupComponent) {
			PopupComponent = (await import('$lib/storyblok/parts/typeform/typeformPopup.svelte')).default;
		}
	}}
>
	<PageGrid16 class="lg:py-20">
		<div
			class="col-span-full px-5 py-[68px] text-center lg:col-start-2 lg:col-end-[16] lg:grid lg:grid-cols-14 lg:gap-x-4 lg:rounded-2xl"
			style="background-color: {content.bg_color}"
		>
			<h1
				style="color: {content.title_color}"
				class="mb-4 text-[44px]/[108%] font-semibold tracking-[-.44px] lg:col-start-4 lg:col-end-12 lg:mb-5 lg:text-[64px]/[110%] lg:tracking-[-.64px]"
			>
				{content.title}
			</h1>
			<div
				style="color: {content.text_color}"
				class="mb-7 text-balance text-[20px]/[140%] tracking-[-.2px] lg:col-start-4 lg:col-end-12 lg:mb-9 lg:text-[24px]/[140%] lg:tracking-[-.24px]"
			>
				<SbRichtext text={content.text} />
			</div>
			<div class="flex justify-center lg:col-start-4 lg:col-end-12">
				<Button
					class={content.cta_color === 'default' ? null : content.cta_color}
					onclick={() => popup?.open()}
				>
					{content.cta_text}
				</Button>
				>
			</div>
		</div>
	</PageGrid16>
</section>

{#if PopupComponent}
	<PopupComponent
		bind:popup
		formId={content.typeform_id}
		onsubmit={async (formId, responseId) => {
			await identifySubmission(formId, responseId);
		}}
	/>
{/if}
